"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MERCHANDISE_DISPLAY = void 0;
var client_1 = require("@apollo/client");
exports.MERCHANDISE_DISPLAY = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation MerchandiseDisplay($input: MerchandiseDisplayInput!) {\n      merchandiseDisplay(input: $input) {\n          success\n      }\n  }\n"], ["\n  mutation MerchandiseDisplay($input: MerchandiseDisplayInput!) {\n      merchandiseDisplay(input: $input) {\n          success\n      }\n  }\n"])));
var templateObject_1;
